// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import { Button, Divider } from '@mui/material';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle'


// CUSTOM 
import { mtDividerUpTable } from '../../commons';
import { alertInformativo } from '../../commons/texts';
import { TableEmployeeTerminal } from '../../components/tables';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { CreateDialogTerminal } from '../../components/modals/terminal';
import { hasPemissions } from '../../commons/utils';


export const Terminals = () => {

  // USE STATE 
  const [modalCreate, setModalCreate] = useState(false);
  const [canCreate, setCanCreate]     = useState<boolean>(false);



    // USE EFFECT 
    useEffect(() => {
      hasPrmissionsCreate();
    }, []);
  
  
    // CONST FUNCTIONS 
    const hasPrmissionsCreate = async() => {

      const hasPermissions = await hasPemissions('modulo.configuracion', 'modulo.terminales', 'create' );

      if ( hasPermissions ) {
            setCanCreate(true);
      }

    }


  // FUNCTIONS OPEN MODALS 
  const openModal = () => {
     setModalCreate(true);
  }

  const handleCloseModalCrear = () => {
     setModalCreate(false);
  } 

  return (
    <div>

        <BreadCrumbsAndTitle
            title="Listado Terminal Empleados" 
            mainModule="configuracion" 
            parent="Listado Terminal Empleados"
            action="" />


        {
           canCreate && <div style={{ display: 'flex', justifyContent: 'end'}}>
                          <Button  variant='contained' sx={{ marginBottom: 3 }} onClick={openModal}>Crear Terminal</Button>
                        </div>
        }   
        

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.employeeTerminal} />
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
        <CreateDialogTerminal open={modalCreate} handleCloseModalCrear={handleCloseModalCrear} />
        
        <TableEmployeeTerminal />
    </div>
  )
}
